<template>
  <div class="display-modal">
    <h3>Shelve this book</h3>
    <div v-if="this.book.length > 0 && !publication.bookId">
      <p>
        You already have a copy of this book on your shelves. Do you want to add
        another?
      </p>
    </div>
    <div v-if="token">
      <div v-if="shelves">
        <form class="pure-form">
          <div
            v-for="shelf in shelves"
            :key="shelf.label"
            >
            <label>
              {{ shelf.description }}
              <input
                type="checkbox"
                :checked="getCheckedValue(shelf)"
                @change="processBookAndShelf($event, shelf.label)"
              />
            </label>
          </div>
          <add-shelf-form></add-shelf-form>
        </form>
      </div>
      <div v-else>
        Fetching shelves
      </div>
    </div>
    <div v-else>
      <p>Log in to add books to your shelves</p>
    </div>
    <button @click="$emit('close')">Close</button>
  </div>
</template>
<script>
import axios from 'axios';
import AddShelfForm from './AddShelfForm';

export default {
  name: 'shelfPicker',
  components: {
    'add-shelf-form': AddShelfForm,
  },
  data() {
    return {
      token: this.$cookies.get('user'),
      targetShelf: '',
      user: {},
      viewedUser: {},
      shelves: [],
      book: {},
    };
  },
  props: ['publication'],
  async mounted() {
    await this.getViewedUser();
    await this.getUser();
    await this.getBook();
    this.getShelves();
  },
  methods: {
    getCheckedValue(shelf) {
      if (this.book.shelves) {
        return this.book.shelves
          .map((thisShelf) => thisShelf.tag)
          .includes(shelf.label);
      }
      return false;
    },
    async getShelves() {
      // Get shelves for the logged in user, not the viewed user
      // Get description, not label
      if (this.user) {
        axios
          .get(`/user/${this.user.username}/shelves`, {
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
          })
          .then((response) => {
            this.shelves = response.data;
            this.targetShelf = this.shelves[0].label;
          });
      }
    },
    async getViewedUser() {
      if (this.$route.params.username) {
        this.viewedUser = {
          username: this.$route.params.username,
        };
      }
    },
    async getUser() {
      return axios
        .get('/user', {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        })
        .then((response) => {
          this.user = response.data;
        });
    },
    async getBook() {
      if (this.publication.bookId) {
        axios
          .get(`/book/${this.publication.bookId}`, {
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
          })
          .then((response) => {
            this.book = response.data;
          });
      } else if (this.user) {
        axios
          .get(
            `/user/${this.user.username}/publication/${this.publication.guid
              || this.publication.publicationId}`,
            {
              headers: {
                Authorization: `Bearer ${this.token}`,
              },
            },
          )
          .then((response) => {
            this.book = response.data;
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    processBookAndShelf(evt, shelfLabel) {
      if (evt.target.checked) {
        this.addPublicationToShelf(shelfLabel);
      } else {
        this.removeBookFromShelf(shelfLabel);
      }
    },
    addPublicationToShelf(shelfLabel) {
      if (this.book.guid) {
        // This is a book already associated to the user
        return this.addBookToShelf(this.book.guid, shelfLabel)
          .then(() => {
            this.flashMessage.show({
              message: `Book added to shelf '${shelfLabel}'`,
            });
          });
      }

      // This is a publication
      return this.addPublicationToUser(
        this.publication.guid || this.publication.publicationId,
      )
        .then((bookData) => {
          console.log('adding book');
          this.addBookToShelf(bookData.data.guid, shelfLabel);
        })
        .then(() => {
          this.flashMessage.show({
            message: `Book added to shelf '${shelfLabel}'`,
          });
        });
    },
    addPublicationToUser(publicationId) {
      return axios.put(
        '/books',
        {
          publicationId,
        },
        {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        },
      );
    },
    addBookToShelf(bookId, shelfLabel) {
      return axios.post(
        `/user/${this.user.username}/shelf/${shelfLabel}`,
        [bookId],
        {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        },
      );
    },
    removeBookFromShelf(shelfLabel) {
      return axios.delete(`/user/${this.user.username}/shelf/${shelfLabel}`, {
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
        data: [this.book.guid],
      });
    },
  },
};
</script>
